import { useEffect, useState } from 'react';
import { auth } from '../../lib/api';

const APPLE_CLIENT_ID = 'dk.visionimpossible.stream.web';
const APPLE_REDIRECT_URI = import.meta.env.DEV
  ? 'http://localhost:5173'
  : 'https://console.visionimpossible.dk';

function LoginPage({ onLogin }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.AppleID) {
        window.AppleID.auth.init({
          clientId: APPLE_CLIENT_ID,
          scope: 'name email',
          redirectURI: APPLE_REDIRECT_URI,
          usePopup: true
        });
      }
    };

    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  const handleAppleSignIn = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await window.AppleID.auth.signIn();
      const response = await auth.signInWithApple(data.authorization.id_token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      onLogin(response.data.accessToken, response.data.profile);
    } catch (err) {
      console.error('Apple Sign In error:', err);
      setError(err.response?.data?.message || err.message || 'Sign in failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100 dark:bg-neutral-950">
      <div className="w-full max-w-sm p-8 rounded-2xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 text-center">
        <h1 className="text-2xl font-bold mb-1">VI Console</h1>
        <p className="text-sm text-neutral-500 mb-8">Performer sign in</p>

        <button
          onClick={handleAppleSignIn}
          disabled={loading}
          className="w-full flex items-center justify-center gap-3 px-6 py-3 rounded-xl bg-neutral-900 dark:bg-white text-white dark:text-neutral-900 font-semibold hover:bg-neutral-700 dark:hover:bg-neutral-200 disabled:opacity-50 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
            <path d="M15.6,7.2c-0.1,0.1-1.8,1-1.8,3.1c0,2.4,2.1,3.3,2.2,3.3c0,0.1-0.3,1.2-1.2,2.3c-0.7,1-1.5,2-2.7,2
              c-1.2,0-1.5-0.7-2.9-0.7c-1.3,0-1.8,0.7-2.9,0.7c-1.1,0-2-0.9-2.8-2c-1.1-1.5-2-4.3-0.8-6.2c0.6-0.9,1.6-1.5,2.7-1.5
              c1.1,0,1.9,0.7,2.6,0.7c0.6,0,1.7-0.8,3-0.7c0.5,0,1.9,0.2,2.8,1.6C15.7,7.1,15.6,7.2,15.6,7.2z M13.1,4.7
              c0.5-0.6,0.9-1.5,0.8-2.4c-0.8,0-1.7,0.5-2.3,1.2c-0.5,0.6-0.9,1.5-0.8,2.3C11.6,5.9,12.5,5.4,13.1,4.7z"/>
          </svg>
          {loading ? 'Signing in...' : 'Sign in with Apple'}
        </button>

        {error && <p className="mt-4 text-sm text-red-500">{error}</p>}
      </div>
    </div>
  );
}

export default LoginPage;
